export const hcaEngineAccessTokenSelux = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiZTljNmNiZC03YThhLTQ5YjMtODFlNS0wM2FlM2Q2NmYwZjEiLCJ0aWQiOiJzZWx1eCIsImlzcyI6InZpYW1lZGljaSJ9.oxuy8HIKEtG6w_BKqY5vOtC3713Rp4OuB8ER0B7npC4';
export const deploymentNamePrefix = 'ComponentsV2-';
